module.exports = __webpack_public_path__ + "img/banner-dog-mob.e4c421e6.jpg";